import React from "react"

const HeroBody = ({ children }) => <div className="hero-body">{children}</div>

export default HeroBody
